import { defineSlotRecipe } from "@chakra-ui/react";
import { checkboxAnatomy } from "@chakra-ui/react/anatomy";

const checkboxRecipe = defineSlotRecipe({
  slots: checkboxAnatomy.keys(),
  variants: {
    variant: {
      selectOption: {
        root: {
          _disabled: {
            cursor: "pointer",
          },
        },
        control: {
          height: "20px",
          width: "20px",
          _disabled: {
            borderColor: "gray.50",
            backgroundColor: "brand.white",
          },
          _checked: {
            _disabled: {
              borderColor: "blue.500",
              backgroundColor: "blue.500",
              color: "white",
            },
          },
        },
        label: {
          _disabled: {
            opacity: 1,
            color: "brand.black",
            cursor: "pointer",
          },
        },
      },
    },
  },
});

export default checkboxRecipe;
